export enum ScreenType {
	GRID = "grid",
	GMAP = "gmap",
	CHART = "chart",
	CARD = "card",
	LIST = "list",
}
